import React from 'react';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface ConsultaIncompletaItem {
  label: string;
  meta: string;
  done: boolean;
  onClick: () => void;
}

interface ConsultaIncompletaCardProps {
  hint: string;
  itens: ConsultaIncompletaItem[];
}

/**
 * Substitui o placeholder de texto puro (`GraficoSH`/`GraficoSM`) quando os
 * filtros obrigatorios ainda nao estao completos, so no mobile. Mostra um
 * checklist clicavel — cada item leva direto ao controle que falta (painel
 * ou seletor de entidades), em vez de deixar o usuario procurar sozinho.
 */
export default function ConsultaIncompletaCard({ hint, itens }: ConsultaIncompletaCardProps) {
  return (
    <div className="windx-consulta-incompleta">
      <div className="windx-consulta-incompleta-icone">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={cssVar('text-accent')} strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 5h18l-7 8v7l-4-2v-5z" />
        </svg>
      </div>
      <div className="windx-consulta-incompleta-titulo">Falta configurar a consulta</div>
      <div className="windx-consulta-incompleta-hint">{hint}</div>
      <div className="windx-consulta-incompleta-lista">
        {itens.map((item) => (
          <button
            key={item.label}
            type="button"
            className="windx-consulta-incompleta-item"
            onClick={item.onClick}
          >
            <span className={`windx-consulta-incompleta-marca${item.done ? ' is-feito' : ''}`} />
            <span className="windx-consulta-incompleta-item-texto">
              <span
                className={`windx-consulta-incompleta-item-label${item.done ? ' is-feito' : ''}`}
              >
                {item.label}
              </span>
              <span className="windx-consulta-incompleta-item-meta">{item.meta}</span>
            </span>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--ee-border-strong)" strokeWidth={2} strokeLinecap="round">
              <path d="m9 6 6 6-6 6" />
            </svg>
          </button>
        ))}
      </div>
    </div>
  );
}
